import React from "react";
import { Trash2 } from "lucide-react";
import "./Videos.scss";

const getInitials = (name) => {
  if (!name) return "?";
  return name
    .split(" ")
    .map((w) => w[0])
    .join("")
    .slice(0, 2);
};

const timeAgo = (dateStr) => {
  if (!dateStr) return "";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins}m ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  if (days < 30) return `${days}d ago`;
  const months = Math.floor(days / 30);
  return `${months}mo ago`;
};

const VideoCommentItem = ({ comment, role, currentUserId, onDelete }) => {
  const isAdmin = role === "admin" || role === "superadmin";
  const isOwner = currentUserId && comment.user?._id === currentUserId;
  const canDelete = isAdmin || isOwner;
  const userName = comment.user?.name || "Unknown";

  return (
    <div className="comment-item">
      <div className="comment-item__avatar">{getInitials(userName)}</div>

      <div className="comment-item__content">
        <div className="comment-item__header">
          <span className="comment-item__name">{userName}</span>
          <span className="comment-item__time">{timeAgo(comment.createdAt)}</span>
        </div>
        <div className="comment-item__message">{comment.message}</div>
      </div>

      {canDelete && (
        <button
          className="comment-item__delete"
          onClick={() => onDelete && onDelete(comment._id)}
          title="Delete comment"
        >
          <Trash2 size={14} />
        </button>
      )}
    </div>
  );
};

export default VideoCommentItem;
